(function () {
  'use strict';

  var Core = window.CartBundleCore;
  if (!Core) return;

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function cartEndpoint(file) {
    return routesRoot() + 'cart/' + file;
  }

  async function responseJson(response) {
    var text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return null;
    }
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });
  }

  function validSections(sections) {
    return Boolean(sections && typeof sections['cart-drawer'] === 'string' && typeof sections['cart-icon-bubble'] === 'string');
  }

  function renderDrawer(sections, cartState) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !validSections(sections)) return false;
    if (cartState && Number.isFinite(Number(cartState.item_count))) {
      drawer.classList.toggle('is-empty', Number(cartState.item_count) === 0);
    } else {
      drawer.classList.remove('is-empty');
    }
    drawer.renderContents({ sections: sections });
    return true;
  }

  function publishCart(cartState, rendered) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cart-bundle-swap',
      cartData: cartState,
      rendered: rendered === true,
    });
  }

  function announce(message, error) {
    var target = error
      ? document.getElementById('CartDrawer-CartErrors')
      : document.getElementById('CartDrawer-LiveRegionText');
    if (!target) return;
    target.textContent = message;
    if (!error) target.setAttribute('aria-hidden', 'false');
  }

  async function refreshTruth() {
    var separator = window.location.search ? '&' : '?';
    var sectionsUrl = window.location.pathname + window.location.search + separator + 'sections=cart-drawer,cart-icon-bubble';
    var results = await Promise.allSettled([
      fetch(routesRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }),
      fetch(sectionsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }),
    ]);
    var cartState = null;
    var sections = null;

    if (results[0].status === 'fulfilled' && results[0].value.ok) cartState = await responseJson(results[0].value);
    if (results[1].status === 'fulfilled' && results[1].value.ok) sections = await responseJson(results[1].value);

    var rendered = renderDrawer(sections, cartState);
    publishCart(cartState, rendered);
    return { cart: cartState, rendered: rendered };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function substitute(template, replacements) {
    return Object.keys(replacements).reduce(function (result, key) {
      return result.split('[' + key + ']').join(String(replacements[key]));
    }, String(template || ''));
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return '£' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  if (!customElements.get('cart-bundle-swap')) {
    customElements.define(
      'cart-bundle-swap',
      class CartBundleSwap extends HTMLElement {
        connectedCallback() {
          this.stateElement = this.querySelector('[data-cart-bundle-state]');
          this.offerElement = this.querySelector('[data-cart-bundle-offer]');
          this.statusElement = this.querySelector('[data-cart-bundle-status]');
          this.data = this.parseState();
          this.offer = this.selectOffer();
          this.render();
          this.addEventListener('click', this.onClick.bind(this));
        }

        parseState() {
          if (!this.stateElement) return null;
          try {
            return JSON.parse(this.stateElement.textContent);
          } catch (_error) {
            return null;
          }
        }

        selectOffer() {
          if (!this.data || !this.data.cart || !Array.isArray(this.data.candidates)) return null;
          var offers = this.data.candidates.map(function (candidate) {
            return Core.evaluateCandidate(candidate, this.data.cart.items);
          }, this);
          return Core.selectOffer(offers);
        }

        pitch() {
          var strings = this.data.strings;
          if (!this.offer.savingKnown) return strings.discounted;
          if (this.offer.saving > 0) {
            return substitute(strings.saving, {
              count: this.offer.boxCount,
              amount: formatMoney(this.offer.saving, this.data.currency),
            });
          }
          if (this.offer.kind === 'near') {
            return substitute(strings.near, {
              missing: this.offer.missingCount,
              amount: formatMoney(Math.max(0, this.offer.delta), this.data.currency),
            });
          }
          return strings.packaging;
        }

        render() {
          if (!this.offerElement || !this.offer || !this.data || !this.data.strings) {
            this.hidden = true;
            return;
          }
          this.hidden = false;
          var candidate = this.offer.candidate;
          var strings = this.data.strings;
          var titleTemplate = this.offer.kind === 'full' ? strings.fullTitle : strings.nearTitle;
          var image = candidate.image
            ? '<a class="cart-bundle-offer__media" href="' + escapeHtml(candidate.url) + '" tabindex="-1" aria-hidden="true"><img src="' + escapeHtml(candidate.image) + '" alt="" width="120" height="120" loading="lazy"></a>'
            : '';
          this.offerElement.innerHTML =
            '<section class="cart-bundle-offer" aria-labelledby="CartBundleOfferTitle">' +
            image +
            '<div class="cart-bundle-offer__content">' +
            '<p class="cart-bundle-offer__eyebrow">' + escapeHtml(strings.eyebrow) + '</p>' +
            '<h3 class="cart-bundle-offer__title" id="CartBundleOfferTitle">' + escapeHtml(substitute(titleTemplate, { title: candidate.title })) + '</h3>' +
            '<p class="cart-bundle-offer__pitch">' + escapeHtml(this.pitch()) + '</p>' +
            (candidate.preorderNote
              ? '<p class="preorder-line cart-bundle-offer__preorder">' + escapeHtml(candidate.preorderNote) + '</p>'
              : candidate.extremeDemandNote
                ? '<p class="extreme-demand-line cart-bundle-offer__extreme-demand">' + escapeHtml(candidate.extremeDemandNote) + '</p>'
                : '') +
            '<button class="button cart-bundle-offer__button" type="button" data-cart-bundle-submit>' +
            '<span>' + escapeHtml(substitute(strings.button, { title: candidate.title })) + '</span>' +
            '</button>' +
            '</div></section>';
        }

        async onClick(event) {
          var button = event.target.closest('[data-cart-bundle-submit]');
          if (!button || !this.contains(button) || this.busy) return;
          this.busy = true;
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          var label = button.querySelector('span');
          var originalLabel = label.textContent;
          label.textContent = this.data.strings.working;

          try {
            await this.swap();
          } catch (_error) {
            await refreshTruth().catch(function () {});
            announce(this.data.strings.errorGeneric, true);
          } finally {
            this.busy = false;
            if (button.isConnected) {
              button.disabled = false;
              button.removeAttribute('aria-disabled');
              label.textContent = originalLabel;
            }
          }
        }

        async swap() {
          var beforeCart = this.data.cart;
          var candidate = this.offer.candidate;
          var boxItem = { id: candidate.variantId, quantity: this.offer.boxCount };
          // Line-item properties set by Liquid (the Pre-order note, or else the extreme-demand "Shipping" note) travel with the box.
          if (candidate.properties && typeof candidate.properties === 'object') boxItem.properties = candidate.properties;
          var addResponse = await postJson(cartEndpoint('add.js'), {
            items: [boxItem],
          });
          var addState = await responseJson(addResponse);
          if (!addResponse.ok || !addState || addState.status) {
            var truth = await refreshTruth();
            var reconciliation = Core.classifyReconciliation(
              beforeCart,
              truth.cart,
              candidate.variantId,
              this.offer.boxCount,
            );
            var message = this.data.strings.errorGeneric;
            if (reconciliation.status === 'none') message = this.data.strings.errorNone;
            if (reconciliation.status === 'partial') message = this.data.strings.errorPartial;
            if (reconciliation.status === 'full') message = this.data.strings.errorAdded;
            announce(message, true);
            return;
          }

          var updateResponse = await postJson(cartEndpoint('update.js'), {
            updates: Core.buildUpdates(this.offer.allocations),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          });
          var updateState = await responseJson(updateResponse);
          if (!updateResponse.ok || !updateState || updateState.errors || !validSections(updateState.sections)) {
            await refreshTruth();
            announce(this.data.strings.errorGeneric, true);
            return;
          }

          var rendered = renderDrawer(updateState.sections, updateState);
          publishCart(updateState, rendered);
          announce(this.data.strings.success, false);
        }
      },
    );
  }

  if (!customElements.get('cart-suggestion-add')) {
    customElements.define(
      'cart-suggestion-add',
      class CartSuggestionAdd extends HTMLElement {
        connectedCallback() {
          var state = this.querySelector('[data-cart-suggestion-strings]');
          try {
            this.strings = JSON.parse(state.textContent);
          } catch (_error) {
            this.strings = { adding: 'Adding…', error: 'That item could not be added.' };
          }
          this.addEventListener('submit', this.onSubmit.bind(this));
        }

        async onSubmit(event) {
          var form = event.target.closest('[data-cart-suggestion-form]');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          var button = form.querySelector('[type="submit"]');
          if (!button || button.disabled) return;
          var label = button.querySelector('span');
          var originalLabel = label.textContent;
          var error = form.querySelector('[role="alert"]');
          button.disabled = true;
          label.textContent = this.strings.adding;
          if (error) error.hidden = true;

          try {
            var formData = new FormData(form);
            var suggestionItem = { id: Number(formData.get('id')), quantity: 1 };
            var properties = {};
            formData.forEach(function (value, name) {
              var match = /^properties\[(.+)\]$/.exec(name);
              if (match) properties[match[1]] = value;
            });
            if (Object.keys(properties).length > 0) suggestionItem.properties = properties;
            var response = await postJson(cartEndpoint('add.js'), {
              items: [suggestionItem],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            });
            var state = await responseJson(response);
            if (!response.ok || !state || state.status || !validSections(state.sections)) {
              await refreshTruth();
              if (error && error.isConnected) {
                error.textContent = this.strings.error;
                error.hidden = false;
              } else {
                announce(this.strings.error, true);
              }
              return;
            }
            var rendered = renderDrawer(state.sections, { item_count: 1 });
            publishCart(state, rendered);
          } catch (_error) {
            await refreshTruth().catch(function () {});
            announce(this.strings.error, true);
          } finally {
            if (button.isConnected) {
              button.disabled = false;
              label.textContent = originalLabel;
            }
          }
        }
      },
    );
  }
})();
